"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reserves = exports.dappWrite = void 0;
var generic_1 = require("./generic");
var assetIdHack = function (assetId) { var _a; return (_a = assetId === null || assetId === void 0 ? void 0 : assetId.split("_")) === null || _a === void 0 ? void 0 : _a[0]; };
var dappWrite = function (config, signerOrKeeper, _fetch) {
    if (_fetch === void 0) { _fetch = fetch; }
    var assets = config.assets, main = config.main, viresAsset = config.viresAsset, mainV1 = config.mainV1;
    var reserveByAssetId = function (assetId) {
        var r = Object.values(assets).find(function (asset) { return asset.id === assetId || asset.aTokenId === assetId; });
        //const r = assets[assetId]
        if (!r)
            throw new Error("Reserve with assetId or aTokenId: ".concat(assetId, " not found, please check config"));
        return r;
    };
    var deposit = function (_a) {
        var assetId = _a.assetId, paymentAmount = _a.paymentAmount, useAsCollateral = _a.useAsCollateral, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "deposit",
                        args: [
                            { type: "string", value: reserveByAssetId(assetId).reserveAddress },
                            { type: "boolean", value: useAsCollateral },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [{ assetId: assetIdHack(assetId), amount: paymentAmount }],
                    }, _fetch)];
            });
        });
    };
    var depositEarlyBirdRefBonus = function (_a) {
        var assetId = _a.assetId, paymentAmount = _a.paymentAmount, useAsCollateral = _a.useAsCollateral, ref = _a.ref, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "depositEarlyBirdRefBonus",
                        args: [
                            { type: "string", value: reserveByAssetId(assetId).reserveAddress },
                            { type: "boolean", value: useAsCollateral },
                            { type: "string", value: ref },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [{ assetId: assetIdHack(assetId), amount: paymentAmount }],
                    }, _fetch)];
            });
        });
    };
    var repay = function (_a) {
        var assetId = _a.assetId, paymentAmount = _a.paymentAmount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "repay",
                        args: [
                            { type: "string", value: reserveByAssetId(assetId).reserveAddress },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [{ assetId: assetIdHack(assetId), amount: paymentAmount }],
                    }, _fetch)];
            });
        });
    };
    var borrow = function (_a) {
        var assetId = _a.assetId, amount = _a.amount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "borrow",
                        args: [
                            { type: "string", value: assetId },
                            { type: "integer", value: amount },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var borrow2 = function (_a) {
        var reserve = _a.reserve, amount = _a.amount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "borrow2",
                        args: [
                            { type: "string", value: reserve },
                            { type: "integer", value: amount },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var withdraw = function (_a) {
        var assetId = _a.assetId, amount = _a.amount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "withdraw",
                        args: [
                            { type: "string", value: assetId },
                            { type: "integer", value: amount },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var withdraw2 = function (_a) {
        var reserve = _a.reserve, amount = _a.amount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "withdraw2",
                        args: [
                            { type: "string", value: reserve },
                            { type: "integer", value: amount },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var enableUseAsCollateral = function (_a) {
        var assetId = _a.assetId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: reserveByAssetId(assetId).reserveAddress,
                        func: "enableUseAsCollateral",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var disableUseAsCollateral = function (_a) {
        var assetId = _a.assetId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "disableUseAsCollateral",
                        args: [
                            { type: "string", value: reserveByAssetId(assetId).reserveAddress },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var redeemAtokens = function (_a) {
        var assetId = _a.assetId, aTokensAmount = _a.aTokensAmount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            var aTokenId;
            return __generator(this, function (_c) {
                aTokenId = reserveByAssetId(assetId).aTokenId;
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "redeemAtokens",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [{ assetId: aTokenId, amount: aTokensAmount }],
                    }, _fetch)];
            });
        });
    };
    var replenishWithAtoken = function (_a) {
        var assetId = _a.assetId, aTokensAmount = _a.aTokensAmount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            var aTokenId;
            return __generator(this, function (_c) {
                aTokenId = reserveByAssetId(assetId).aTokenId;
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "replenishWithAtoken",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [{ assetId: aTokenId, amount: aTokensAmount }],
                    }, _fetch)];
            });
        });
    };
    var repayWithAtoken = function (_a) {
        var assetId = _a.assetId, aTokensAmount = _a.aTokensAmount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            var aTokenId;
            return __generator(this, function (_c) {
                aTokenId = reserveByAssetId(assetId).aTokenId;
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "repayWithAtoken",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [{ assetId: aTokenId, amount: aTokensAmount }],
                    }, _fetch)];
            });
        });
    };
    var mintAtoken = function (_a) {
        var assetId = _a.assetId, aTokensAmount = _a.aTokensAmount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "mintAtoken",
                        args: [
                            { type: "string", value: reserveByAssetId(assetId).aTokenId },
                            { type: "integer", value: aTokensAmount },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var collapseDebt = function (_a) {
        var assetId = _a.assetId, amount = _a.amount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
            dApp: main,
            func: "collapse",
            args: [
                { type: "string", value: reserveByAssetId(assetId).reserveAddress },
                { type: "integer", value: amount },
            ],
            fee: fee,
            feeAssetId: feeAssetId,
            payment: [],
        }, _fetch);
    };
    var stakeVires = function (_a) {
        var user = _a.user, amount = _a.amount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
            dApp: viresAsset.reserveAddress,
            func: "stakeVires",
            args: [{ type: "string", value: user }],
            fee: fee,
            feeAssetId: feeAssetId,
            payment: [{ assetId: viresAsset.id, amount: amount }],
        }, _fetch);
    };
    var unstakeVires = function (_a) {
        var user = _a.user, amount = _a.amount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
            dApp: viresAsset.reserveAddress,
            func: "unstakeVires",
            args: [
                { type: "string", value: user },
                { type: "integer", value: amount },
            ],
            fee: fee,
            feeAssetId: feeAssetId,
            payment: [],
        }, _fetch);
    };
    var claimEbReward = function (_a) {
        var amount = _a.amount, stake = _a.stake, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
            dApp: main,
            func: "claimEbReward",
            args: [
                { type: "integer", value: amount },
                { type: "boolean", value: stake },
            ],
            fee: fee,
            feeAssetId: feeAssetId,
            payment: [],
        }, _fetch);
    };
    var claimEbReward2 = function (_a) {
        var amount = _a.amount, lock = _a.lock, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
            dApp: main,
            func: "claimEbReward2",
            args: [
                { type: "integer", value: amount },
                { type: "boolean", value: lock },
            ],
            fee: fee,
            feeAssetId: feeAssetId,
            payment: [],
        }, _fetch);
    };
    var claimReward = function (_a) {
        var assetId = _a.assetId, amount = _a.amount, stake = _a.stake, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
            dApp: main,
            func: "claimReward",
            args: [
                { type: "string", value: reserveByAssetId(assetId).reserveAddress },
                { type: "integer", value: amount },
                { type: "boolean", value: stake },
            ],
            fee: fee,
            feeAssetId: feeAssetId,
            payment: [],
        }, _fetch);
    };
    var claimReward2 = function (_a) {
        var assetId = _a.assetId, amount = _a.amount, lock = _a.lock, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
            dApp: main,
            func: "claimReward2",
            args: [
                { type: "string", value: reserveByAssetId(assetId).reserveAddress },
                { type: "integer", value: amount },
                { type: "boolean", value: lock },
            ],
            fee: fee,
            feeAssetId: feeAssetId,
            payment: [],
        }, _fetch);
    };
    var claimAllRewardsAndAllEbAvailable = function (_a) {
        var stake = _a.stake, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
            dApp: main,
            func: "claimAllRewardsAndAllEbAvailable",
            args: [{ type: "boolean", value: stake }],
            fee: fee,
            feeAssetId: feeAssetId,
            payment: [],
        }, _fetch);
    };
    var claimAllRewardsAndAllEbAvailable2 = function (_a) {
        var lock = _a.lock, unstakeLegacy = _a.unstakeLegacy, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
            dApp: main,
            func: "claimAllRewardsAndAllEbAvailable2",
            args: [
                { type: "boolean", value: lock },
                { type: "boolean", value: unstakeLegacy },
            ],
            fee: fee,
            feeAssetId: feeAssetId,
            payment: [],
        }, _fetch);
    };
    var lock = function (_a) {
        var amount = _a.amount, factor = _a.factor, migrate = _a.migrate, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: mainV1 !== null && mainV1 !== void 0 ? mainV1 : main,
                        func: "lockVires",
                        args: [
                            { type: "integer", value: factor },
                            { type: "boolean", value: migrate },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: amount ? [{ assetId: viresAsset.id, amount: amount }] : [],
                    }, _fetch)];
            });
        });
    };
    var withdrawUnlocked = function (_a) {
        var _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: mainV1 !== null && mainV1 !== void 0 ? mainV1 : main,
                        func: "withdrawUnlockedVires",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var withdrawAllPossibleVires = function (_a) {
        var _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: mainV1 !== null && mainV1 !== void 0 ? mainV1 : main,
                        func: "withdrawAllPossibleVires",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var claimProtocolProfitFrom = function (_a) {
        var from = _a.from, relock = _a.relock, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: mainV1 !== null && mainV1 !== void 0 ? mainV1 : main,
                        func: "claimProtocolProfitFrom",
                        args: [
                            { type: "string", value: from },
                            { type: "boolean", value: relock },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var setClaimDelegation = function (_a) {
        var address = _a.address, allowRelock = _a.allowRelock, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.dividends,
                        func: "setClaimDelegation",
                        args: [
                            { type: "string", value: address },
                            { type: "boolean", value: allowRelock },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var removeClaimDelegation = function (_a) {
        var _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.dividends,
                        func: "removeClaimDelegation",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var supplyProtectedCollateral = function (_a) {
        var assetId = _a.assetId, paymentAmount = _a.paymentAmount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.protectedReserve,
                        func: "supply",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [{ assetId: assetIdHack(assetId), amount: paymentAmount }],
                    }, _fetch)];
            });
        });
    };
    var withdrawProtectedCollateral = function (_a) {
        var assetId = _a.assetId, amount = _a.amount, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "withdrawProtectedCollateral",
                        args: [
                            { type: "string", value: assetId },
                            { type: "integer", value: amount },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var protectCollateral = function (_a) {
        var reserve = _a.reserve, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "protectCollateral",
                        args: [{ type: "string", value: reserve }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var propose = function (_a) {
        var txId = _a.txId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.voting,
                        func: "propose",
                        args: [{ type: "string", value: txId }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var voteYes = function (_a) {
        var txId = _a.txId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.voting,
                        func: "voteYes",
                        args: [{ type: "string", value: txId }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var voteNo = function (_a) {
        var txId = _a.txId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.voting,
                        func: "voteNo",
                        args: [{ type: "string", value: txId }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var retract = function (_a) {
        var txId = _a.txId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.voting,
                        func: "retract",
                        args: [{ type: "string", value: txId }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var retractProposal = function (_a) {
        var txId = _a.txId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.voting,
                        func: "retractProposal",
                        args: [{ type: "string", value: txId }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var lockSupply = function (_a) {
        var assetId = _a.assetId, paymentAmount = _a.paymentAmount, period = _a.period, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: main,
                        func: "lockSupply",
                        args: [
                            { type: "string", value: reserveByAssetId(assetId).reserveAddress },
                            { type: "integer", value: period },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: (paymentAmount || 0) > 0
                            ? [{ assetId: assetIdHack(assetId), amount: paymentAmount || 0 }]
                            : [],
                    }, _fetch)];
            });
        });
    };
    var startVestingAll = function (_a) {
        var _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.vesting,
                        func: "startVestingAll",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var vestingAllClaimRewards = function (_a) {
        var _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.vestingAll,
                        func: "claimRewards",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var withdrawVested = function (_a) {
        var _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.vesting,
                        func: "withdrawVested",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var withdrawUnlockedLPTokens = function (_a) {
        var assetId = _a.assetId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.main3,
                        func: "withdrawUnlockedLPTokens",
                        args: [{ type: "string", value: reserveByAssetId(assetId).aTokenId }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var withdrawSlashedLockedLPTokens = function (_a) {
        var assetId = _a.assetId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.main3,
                        func: "withdrawSlashedLockedLPTokens",
                        args: [{ type: "string", value: reserveByAssetId(assetId).aTokenId }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var supplyUnlockedLPTokens = function (_a) {
        var assetId = _a.assetId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.main3,
                        func: "supplyUnlockedLPTokens",
                        args: [{ type: "string", value: reserveByAssetId(assetId).aTokenId }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var redeemUnlockedLPTokens = function (_a) {
        var assetId = _a.assetId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.main3,
                        func: "redeemUnlockedLPTokens",
                        args: [{ type: "string", value: reserveByAssetId(assetId).aTokenId }],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    //withdrawVestedAllUSDN
    var withdrawVestedAllUSDN = function (_a) {
        var whale = _a.whale, regular = _a.regular, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.liquidaoAll,
                        func: "withdrawVestedAllUSDN",
                        args: [
                            { type: "boolean", value: whale },
                            { type: "boolean", value: regular },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    //func withdrawVestedAllSURF(whale: Boolean, regular: Boolean)
    var withdrawVestedAllSURF = function (_a) {
        var whale = _a.whale, regular = _a.regular, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.liquidaoAll,
                        func: "withdrawVestedAllSURF",
                        args: [
                            { type: "boolean", value: whale },
                            { type: "boolean", value: regular },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var withdrawVestedSURF2 = function (_a) {
        var whale = _a.whale, regular = _a.regular, stake = _a.stake, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.liquidaoAll,
                        func: "withdrawVestedSURF2",
                        args: [
                            { type: "integer", value: whale },
                            { type: "integer", value: regular },
                            { type: "boolean", value: stake },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var convertToUSDN = function (_a) {
        var _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.liquidaoAll,
                        func: "convertToUSDN",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var withdrawAsLP = function (_a) {
        var whale = _a.whale, regular = _a.regular, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.main4,
                        func: "withdrawAsLP",
                        args: [
                            { type: "integer", value: whale },
                            { type: "integer", value: regular },
                        ],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [],
                    }, _fetch)];
            });
        });
    };
    var importLP = function (_a) {
        var amount = _a.amount, assetId = _a.assetId, _b = _a.fee, fee = _b === void 0 ? generic_1.invocationFee : _b, feeAssetId = _a.feeAssetId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, (0, generic_1.broadcastInvoke)(config, signerOrKeeper, {
                        dApp: config.main4,
                        func: "importLP",
                        args: [],
                        fee: fee,
                        feeAssetId: feeAssetId,
                        payment: [{ assetId: assetId, amount: amount }],
                    }, _fetch)];
            });
        });
    };
    return {
        deposit: deposit,
        depositEarlyBirdRefBonus: depositEarlyBirdRefBonus,
        withdraw: withdraw,
        withdraw2: withdraw2,
        borrow: borrow,
        borrow2: borrow2,
        repay: repay,
        redeemAtokens: redeemAtokens,
        replenishWithAtoken: replenishWithAtoken,
        repayWithAtoken: repayWithAtoken,
        collapseDebt: collapseDebt,
        mintAtoken: mintAtoken,
        enableUseAsCollateral: enableUseAsCollateral,
        disableUseAsCollateral: disableUseAsCollateral,
        stakeVires: stakeVires,
        unstakeVires: unstakeVires,
        claimEbReward: claimEbReward,
        claimEbReward2: claimEbReward2,
        claimReward: claimReward,
        claimReward2: claimReward2,
        claimAllRewardsAndAllEbAvailable: claimAllRewardsAndAllEbAvailable,
        claimAllRewardsAndAllEbAvailable2: claimAllRewardsAndAllEbAvailable2,
        //fork mainV1
        lock: lock,
        //fork mainV1
        withdrawAllPossibleVires: withdrawAllPossibleVires,
        //fork mainV1
        withdrawUnlocked: withdrawUnlocked,
        //fork mainV1
        claimProtocolProfitFrom: claimProtocolProfitFrom,
        setClaimDelegation: setClaimDelegation,
        removeClaimDelegation: removeClaimDelegation,
        withdrawProtectedCollateral: withdrawProtectedCollateral,
        protectCollateral: protectCollateral,
        supplyProtectedCollateral: supplyProtectedCollateral,
        propose: propose,
        voteYes: voteYes,
        voteNo: voteNo,
        retract: retract,
        retractProposal: retractProposal,
        lockSupply: lockSupply,
        startVestingAll: startVestingAll,
        withdrawVested: withdrawVested,
        //main3
        withdrawUnlockedLPTokens: withdrawUnlockedLPTokens,
        withdrawSlashedLockedLPTokens: withdrawSlashedLockedLPTokens,
        supplyUnlockedLPTokens: supplyUnlockedLPTokens,
        redeemUnlockedLPTokens: redeemUnlockedLPTokens,
        //liquidaoAll
        convertToUSDN: convertToUSDN,
        withdrawVestedAllUSDN: withdrawVestedAllUSDN,
        withdrawVestedAllSURF: withdrawVestedAllSURF,
        withdrawVestedSURF2: withdrawVestedSURF2,
        //vestingAll
        vestingAllClaimRewards: vestingAllClaimRewards,
        //main4
        withdrawAsLP: withdrawAsLP,
        importLP: importLP,
    };
};
exports.dappWrite = dappWrite;
//Backward Compatibility
exports.reserves = exports.dappWrite;
//# sourceMappingURL=dappWrite.js.map